/**
 * Scrolls an element vertically
 * @param element
 * @param globalBounds
 * @param scrollTo
 */
export function scrollVertical(
  element: HTMLElement,
  globalBounds: { top: number; bottom: number; height: number },
  scrollTo?: 'back' | 'next' | null
) {
  const scrollHeight = element.scrollHeight;
  if (scrollHeight <= element.offsetHeight) {
    return;
  }
  const bounds = element.getBoundingClientRect();
  const relativeTop = globalBounds.top - bounds.top;
  const relativeBottom = globalBounds.bottom - bounds.bottom;
  const padding = 1;
  if (relativeTop <= 0 && scrollTo !== 'next') {
    element.scrollTop = element.scrollTop + relativeTop - padding;
  } else if (relativeBottom > 0 && scrollTo !== 'back') {
    element.scrollTop = element.scrollTop + relativeBottom + padding;
  }
}

/**
 * Checks to see if the top of an `element` + 1
 * is closer to the top of the viewport than the top of a `container` element
 * @param container
 * @param element
 * @returns `true` or `false`
 */
export function elementTopIsClipped(container: HTMLElement, element: HTMLElement) {
  const cRect = container.getBoundingClientRect() as DOMRect;
  const eRect = element.getBoundingClientRect() as DOMRect;
  return eRect.top + 1 < cRect.top;
}

/**
 * Checks to see if the distance to the bottom of an `element` + 1
 * is farther from the top of the viewport than the bottom of a `container` element
 * @param container
 * @param element
 * @returns `true` or `false`
 */
export function elementBottomIsClipped(container: HTMLElement, element: HTMLElement) {
  const cRect = container.getBoundingClientRect() as DOMRect;
  const eRect = element.getBoundingClientRect() as DOMRect;
  return eRect.top + eRect.height - 1 > cRect.top + cRect.height;
}
